/* eslint-disable quotes */
// Single entry point to report errors - Using AppSignal
window.$ = window.$ || require('jquery');
window.jQuery = window.jQuery || window.$;
import Appsignal from '@appsignal/javascript';

const errorsToIgnore = [
  `null is not an object (evaluating 'W.embeds.initObserver.observe')`,
  `TypeError: null is not an object (evaluating 'W.embeds.initObserver.observe')`,
  `TypeError: Cannot set property 'href' of null`,
  `TypeError: null is not an object (evaluating 'g.href = "tel:" + mobile_number')`,
  `eventTask 'undefined.addEventListener:MSTransitionEnd': can not transition to 'running', expecting state 'scheduled', was 'notScheduled'.`
];

function handleAjaxResponse(responseData) {
  let errorObj, errorText;
  try {
    // Populate errorText with the comment errors
    errorObj = window.$.parseJSON(responseData);
  }
  catch (err) {
    // If the responseText is not valid JSON (like if a 500 exception was thrown), populate errors with a generic error message.
    errorObj = { error: 'Unknown error processing server response' };
  }
  // Determine our response object type
  if (Array.isArray(errorObj)) {
    // An array of string, typically used by best in place respond_with_bip methods in controller
    errorText = errorObj.join();
  }
  else if (typeof (errorObj.error) != 'undefined') {
    errorText = errorObj.error;
  }
  else if (typeof (errorObj) == 'string') {
    errorText = errorObj;
  }
  else if (errorObj && errorObj.statusText) {
    errorText = errorObj.statusText;
  }
  else {
    errorText = 'Unspecified error';
  }
  // Insert error list into form
  window.notie.alert({ type: 3, text: errorText, position: 'top', stay: true });
}

// For handling error responses from $.get and what not
export const handleAjaxResponseOnFail = function(data, status, xhr) {
  // check to see if data is even defined
  if (data && data.responseText) handleAjaxResponse(data.responseText);
  if (data && data.statusText) handleAjaxResponse(JSON.stringify(data));
};

export const handleAjaxResponseOnFormFail = function(evt, xhr, status, error) {
  // Only handle actual errors (status codes >= 400)
  if (xhr && xhr.status >= 400 && xhr.responseText) {
    handleAjaxResponse(xhr.responseText);
  }
};

window.runChecks = function() {
  if (!window.appsignal) {
    window.console.warn('AppSignal.js did not load.');
  }
  else if (!window.$ && !$) {
    let e = new Error('jQuery did not load');
    window.console.error(e);
    window.appsignal && window.appsignal.sendError(e);
    return false;
  }
  else {
    return false; // Disable the snippit for now
  }
};

window.isDev = function() {
  return window['env'] === 'development';
};
window.notie = window.notie || require('notie/dist/notie.js');

function reportAlert(title = null, info = null, type = 'info', url, url_target) {
  window.notie.alert({
    type,
    text:
      `<div class="row justify-content-center">` +
      ((title && `<h4 class="col-sm-12">${title}</h4>`) || '') +
      ((info && `<p class="col-sm-12">${info}</p>`) || '') +
      `</div>`,
    time: 15
  });
}

window.reportAlert = reportAlert;

function reportError(title, info) {
  reportAlert(title, info, 'error');
}

window.reportError = reportError;

function reportWarning(title, info) {
  reportAlert(title, info, 'warning');
}

window.reportWarning = reportWarning;

function reportInfo(title, info) {
  reportAlert(title, info, 'info');
}

window.reportInfo = reportInfo;

function reportSuccess(title, info) {
  reportAlert(title, info, 'success');
}

window.reportSuccess = reportSuccess;

/**
 * junkMessage - shame devs until they stop using an improper function
 * @param junkName the name of the function you wish people would not use
 */
window.junkMessage = function(junkName) {
  console.warn(`🗑 🚮 ${junkName} is a junk function, please refactor the code that uses this! 😷 🤒`);
};

window.drainNotieQueue = (queue, $, appsignal) => $(function() {
  let notieOver = window.subdomain === 'www' ? {} : { time: 7, position: 'top' };
  try{
    queue.map(a => window.notie.alert({ ...a, ...notieOver }));
    queue = [];
  }
  catch (e) {
    console.error(e);
    appsignal && appsignal.sendError(e);
  }
});

window.drainErrorQueue = (queue, $, appsignal) => $(function() {
  try{
    queue.map(a => appsignal && appsignal.sendError(...a));
    queue = [];
  }
  catch (e) {
    console.error(e);
    appsignal && appsignal.sendError(e);
  }
});

export function errorHandlingInit(REV) {
  let appsignal;
  if (!window.current_user) {
    window.current_user = {
      id: null,
      guest_id: null,
      userLogin: null,
      username: null,
      email: null,
      created_at: null,
      user_hash: null,
      isWyIp: false,
      isLoggedIn: false,
      isGuest: false,
      isEmp: false,
      isUser: false,
      src: null,
      rep: null,
      cartId: null,
      cartQty: 0,
      cartTotal: 0
    };
    appsignal = appsignalInit(REV);
    // Reduce noise on WWW: only log this in CRM development
    if (window.isDev && window.isDev() && window.subdomain === 'crm') {
      console.debug('current_user did not load!', REV);
    }
  }
  else {
    appsignal = appsignalInit(REV);
  }

  // Check if environment was properly initialized
  // WWW: relies on globals.json loaded by primeval.js
  // CRM: relies on #page-config element parsed by initWindowGlobals()
  // Note: page_config.js now auto-initializes on import, so this should rarely trigger
  if (window['env'] === undefined || window['env'] === null) {
    // Detect context from URL since window.subdomain may also be unset
    const hostname = window.location.hostname || '';
    const pathname = window.location.pathname || '';
    const isCrm = hostname.startsWith('crm.') || hostname.includes('.crm.');
    const isPreview = pathname.includes('/preview') || pathname.includes('/embed');
    const hasPageConfig = !!document.getElementById('page-config');

    if (isCrm) {
      // CRM: Some pages (embeds, previews) intentionally don't have full page config
      if (isPreview || !hasPageConfig) {
        // Expected behavior for preview/embed pages - just log locally
        console.warn('CRM page loaded without window.env (embed/preview mode)', { pathname });
      } else {
        // Race condition: #page-config exists but window.env not set
        // Try to recover by importing and calling initWindowGlobals
        console.warn('CRM: Recovering from window.env race condition');
        try {
          // Dynamic import to avoid circular dependency issues
          import('common/page_config').then(({ initWindowGlobals }) => {
            initWindowGlobals();
          });
        } catch (e) {
          console.error('Failed to recover window.env:', e);
        }
      }
    } else {
      // WWW: Set a fallback - globals.json may still be loading
      if (!window.env) {
        window.env = 'production'; // Safe default
        console.warn('WWW: window.env fallback to production');
      }
    }
  }

  // Configure AppSignal to catch jQuery errors
  configureAppsignalJQueryIntegration(appsignal);

  //TODO: refactor locations that use this
  window.$.fn.unblockUI = function() {
    console.warn('$.unblockUI is deprecated; use window.unblockUI instead');
    if (window.unblockUI) window.unblockUI();
  };
  window.$.unblockUI = window.$.fn.unblockUI;

  // Create ErrorReporter interface on window (routes to AppSignal)
  window.ErrorReporter = createErrorReporter(appsignal);

  return appsignal;
}

/**
 * Configure AppSignal to catch and report jQuery errors
 * Wraps $.ready(), $.ajaxError(), and $.event.add() to report errors
 */
function configureAppsignalJQueryIntegration(appsignal) {
  // Skip if no appsignal, no jQuery, or using null adapter in development
  if (!appsignal || !window.$ || typeof appsignal.sendError !== 'function') return;
  if (appsignal._isNullAdapter) return;

  try {
    const $ = window.$;

    // Helper to log errors to AppSignal and console
    const logError = (error) => {
      appsignal.sendError(error);
      if (window.console) {
        console.log(error.message + ' [reported to AppSignal]');
      }
    };

    // Wrap $.ajaxError to report AJAX errors
    $(document).ajaxError((event, xhr, settings, thrownError) => {
      if (xhr.status && xhr.status >= 500) {
        const errorMessage = thrownError || `jQuery ajax error for ${settings.type}`;
        const error = new Error(errorMessage);
        const tags = {
          ...(appsignal._defaultTags || {}),
          status: xhr.status,
          url: settings.url,
          type: settings.type,
          isAjax: true
        };
        appsignal.sendError(error, (span) => {
          span.setTags(tags);
          span.setNamespace('frontend');
        });
      }
    });

    // Wrap $.fn.ready to catch errors in ready handlers
    const originalReady = $.fn.ready;
    $.fn.ready = function(fn) {
      return originalReady.call(this, function($) {
        try {
          fn($);
        } catch (error) {
          logError(error);
        }
      });
    };

    // Wrap $.event.add to catch errors in event handlers
    const originalEventAdd = $.event.add;
    $.event.add = function(elem, types, handler, data, selector) {
      const wrapHandler = (fn) => {
        return function() {
          try {
            return fn.apply(this, arguments);
          } catch (error) {
            logError(error);
          }
        };
      };

      let wrappedHandler;
      if (handler.handler) {
        // Handler is an object with a handler property
        const originalHandler = handler.handler;
        handler.handler = wrapHandler(originalHandler);
        wrappedHandler = handler;
        if (originalHandler.guid) {
          handler.handler.guid = originalHandler.guid;
        } else {
          handler.handler.guid = originalHandler.guid = $.guid++;
        }
      } else {
        // Handler is a function
        const originalHandler = handler;
        wrappedHandler = wrapHandler(originalHandler);
        if (originalHandler.guid) {
          wrappedHandler.guid = originalHandler.guid;
        } else {
          wrappedHandler.guid = originalHandler.guid = $.guid++;
        }
      }

      return originalEventAdd.call(this, elem, types, wrappedHandler, data, selector);
    };
  } catch (error) {
    if (!window.isDev || !window.isDev()) {
      console.warn('There was a problem configuring AppSignal jQuery integration', error);
    }
    appsignal && appsignal.sendError(error);
  }
}

/**
 * Create ErrorReporter interface that forwards to AppSignal
 * Unified error reporting for frontend JavaScript
 * Works with both real AppSignal and null adapter
 *
 * Namespace Structure (configure notifications per namespace in AppSignal):
 *   Severity | Namespace          | Notification Setting
 *   ---------|--------------------|-----------------------
 *   Error    | frontend           | First in Deploy
 *   Warning  | frontend_warning   | First Occurrence
 *   Info     | frontend_info      | Never Notify
 *
 * See: https://docs.appsignal.com/application/notification-settings.html
 */
function createErrorReporter(appsignal) {
  const canSendErrors = appsignal && typeof appsignal.sendError === 'function';
  const isNullAdapter = appsignal && appsignal._isNullAdapter;

  // Get default tags from appsignal instance (set during init)
  const getDefaultTags = () => appsignal?._defaultTags || {};

  // Helper to send error to AppSignal with namespace
  // Namespace determines notification settings in AppSignal dashboard
  const sendToNamespace = (error, extra, namespace) => {
    if (!canSendErrors || isNullAdapter) return false;
    try {
      const errorObj = error instanceof Error ? error : new Error(String(error));
      const tags = { ...getDefaultTags(), ...extra };

      // AppSignal sendError signature: sendError(error, callback)
      // The callback receives a span object to set tags, namespace, etc.
      appsignal.sendError(errorObj, (span) => {
        span.setTags(tags);
        span.setNamespace(namespace);
      });
      return true;
    } catch (e) {
      console.warn('[ErrorReporter] Failed to send to AppSignal:', e);
      return false;
    }
  };

  return {
    enabled: canSendErrors && !isNullAdapter,
    // Regular errors go to 'frontend' namespace
    error: (error, extra = {}) => {
      console.error('[ErrorReporter]', error, extra);
      if (sendToNamespace(error, extra, 'frontend')) {
        console.log('[ErrorReporter] ✅ Sent to AppSignal:', error?.message || error);
      } else if (isNullAdapter) {
        console.debug('[ErrorReporter] Skipped (null adapter)');
      }
    },
    // Warnings go to 'frontend_warning' namespace
    warning: (error, extra = {}) => {
      console.warn('[ErrorReporter]', error, extra);
      sendToNamespace(error, extra, 'frontend_warning');
    },
    // Critical errors go to 'frontend' namespace with critical tag
    critical: (error, extra = {}) => {
      console.error('[ErrorReporter CRITICAL]', error, extra);
      sendToNamespace(error, { ...extra, severity: 'critical' }, 'frontend');
    },
    // Informational events go to 'frontend_info' namespace
    // Configure "Never Notify" for this namespace in AppSignal
    informational: (message, extra = {}) => {
      console.info('[ErrorReporter]', message, extra);
      sendToNamespace(message, extra, 'frontend_info');
    },
    info: (message, extra = {}) => console.info('[ErrorReporter]', message, extra),
    debug: (message, extra = {}) => console.debug('[ErrorReporter]', message, extra)
  };
}

/**
 * Create a null/no-op AppSignal adapter for development or when AppSignal fails
 * Has the same interface as real AppSignal but does nothing
 */
function createNullAppsignal() {
  return {
    // Match the real AppSignal API - sendError(error, callback)
    sendError: (error, callback) => {
      if (window.isDev && window.isDev()) {
        // Create a mock span to capture tags for logging
        const mockTags = {};
        let mockNamespace = 'frontend';
        const mockSpan = {
          setTags: (tags) => Object.assign(mockTags, tags),
          setNamespace: (ns) => { mockNamespace = ns; },
          setName: () => {},
          setCategory: () => {},
          setBody: () => {},
          setError: () => {},
          close: () => {}
        };
        if (typeof callback === 'function') {
          callback(mockSpan);
        }
        const severity = mockTags.severity || 'unknown';
        console.debug(`[AppSignal:dev] sendError (${severity}):`, error?.message || error, { tags: mockTags, namespace: mockNamespace });
      }
    },
    wrap: (fn) => fn,
    createSpan: () => ({
      setName: () => {},
      setCategory: () => {},
      setBody: () => {},
      setTags: () => {},
      setNamespace: () => {},
      setError: () => {},
      close: () => {}
    }),
    use: () => {},
    demo: () => {},
    addBreadcrumb: () => {},
    _defaultTags: {},
    _namespace: 'frontend',
    _isNullAdapter: true
  };
}

function appsignalInit(REV) {
  // In development, use null adapter to avoid errors and noise
  if (window.env === 'development') {
    console.debug('[AppSignal] Development mode - using null adapter');
    const nullAdapter = createNullAppsignal();
    window.appsignal = nullAdapter;
    return nullAdapter;
  }

  // AppSignal frontend key is injected at webpack build time (environment-specific)
  const appsignalKey = process.env.APPSIGNAL_FRONTEND_KEY;
  if (!appsignalKey) {
    console.warn('[AppSignal] No frontend key configured - using null adapter');
    const nullAdapter = createNullAppsignal();
    window.appsignal = nullAdapter;
    return nullAdapter;
  }

  try {
    // AppSignal Frontend API Key (injected at build time from Rails credentials)
    const appsignal = new Appsignal({
      key: appsignalKey,
      revision: REV,
      ignoreErrors: errorsToIgnore
    });

    // Verify the appsignal object has required methods (defensive check)
    // Note: AppSignal JS v1.6+ uses sendError, not setTag on main instance
    if (typeof appsignal.sendError !== 'function') {
      console.error('[AppSignal] sendError method not available - using null adapter');
      const nullAdapter = createNullAppsignal();
      window.appsignal = nullAdapter;
      return nullAdapter;
    }

    // Store default tags for use with sendError calls
    // In AppSignal JS, tags are passed per-error, not set globally
    const subdomain = window.subdomain || 'www';
    const defaultTags = {
      // Environment context
      source: 'frontend',
      environment: window.env || 'unknown',
      subdomain: subdomain,
      locale: window.locale || 'unknown',

      // Page context
      page_url: window.location.href,
      page_path: window.location.pathname,
      page_host: window.location.hostname,
      page_protocol: window.location.protocol,
      page_referrer: document.referrer || 'direct',
      page_title: document.title?.substring(0, 100) || '',

      // Browser context
      user_agent: navigator.userAgent?.substring(0, 300) || '',
      browser_language: navigator.language || '',
      browser_platform: navigator.platform || '',
      browser_vendor: navigator.vendor || '',
      browser_online: navigator.onLine,
      browser_cookies_enabled: navigator.cookieEnabled,

      // Screen context
      screen_width: window.screen?.width || 0,
      screen_height: window.screen?.height || 0,
      viewport_width: window.innerWidth || 0,
      viewport_height: window.innerHeight || 0,
      device_pixel_ratio: window.devicePixelRatio || 1,

      // Performance context (if available)
      page_load_time: performance?.timing ?
        (performance.timing.loadEventEnd - performance.timing.navigationStart) : null,

      // Timestamp
      client_timestamp: new Date().toISOString()
    };

    // Add user context if available
    // Note: current_user.id IS the party_id in this application
    if (window.current_user && window.current_user.id) {
      defaultTags.party_id = String(window.current_user.id); // Party ID - primary identifier
      defaultTags.user_id = String(window.current_user.id);  // Alias for party_id
      defaultTags.user_email = window.current_user.email || '';
      defaultTags.user_login = window.current_user.userLogin || '';
      defaultTags.user_name = window.current_user.username || '';
      defaultTags.is_employee = String(window.current_user.isEmp || false);
      defaultTags.is_guest = String(window.current_user.isGuest || false);
      defaultTags.is_logged_in = String(window.current_user.isLoggedIn || false);
      defaultTags.is_trade_pro = String(window.current_user.isTradePro || false);
      defaultTags.cart_id = window.current_user.cartId ? String(window.current_user.cartId) : '';
    }

    // Add tracking context if available
    if (window.tracVis) {
      defaultTags.visitor_id = window.tracVis;
    }
    if (window.visitorCountry) {
      defaultTags.visitor_country = window.visitorCountry;
    }
    if (window.isGdprCountry !== undefined) {
      defaultTags.is_gdpr_country = String(window.isGdprCountry);
    }

    // Store default tags on the appsignal instance for later use
    appsignal._defaultTags = defaultTags;

    console.log(`[AppSignal] Initialized for ${window.env} (source: frontend)`);

    // Store globally for access
    window.appsignal = appsignal;

    return appsignal;
  }
  catch (e) {
    console.error('AppSignal initialization error', e);
    // Return null adapter instead of null to prevent crashes
    const nullAdapter = createNullAppsignal();
    window.appsignal = nullAdapter;
    return nullAdapter;
  }
}

function checkForAds() {
  if (window.wyTrackingDisabled) {
    // Ad blocker detected - we still want to track errors but note it
    if (window.appsignal && typeof window.appsignal.setTag === 'function') {
      window.appsignal.setTag('ad_blocker', 'true');
    }
  }
}

function onLoadStartAdCheck() {
  // Ad blockers generally execute just after load, let's delay ourselves to get behind it.
  setTimeout(checkForAds, 1);
}

if (window.addEventListener !== undefined) {
  window.addEventListener('load', onLoadStartAdCheck, false);
}
else {
  window.attachEvent('onload', onLoadStartAdCheck);
}

window.reportErrorToUser = messageOrEvent => {
  window.notie.alert({ type: 3, text: messageOrEvent, position: 'top' });
};

// Test function for AppSignal - call window.testAppSignal() in console
// Or add ?test_appsignal=1 to any URL to auto-trigger
window.testAppSignal = function() {
  console.log('[AppSignal Test] Starting test...');
  console.log('[AppSignal Test] appsignal object:', window.appsignal);
  console.log('[AppSignal Test] ErrorReporter:', window.ErrorReporter);
  console.log('[AppSignal Test] ErrorReporter.enabled:', window.ErrorReporter?.enabled);

  if (!window.ErrorReporter) {
    console.error('[AppSignal Test] FAIL: ErrorReporter not found');
    return false;
  }

  try {
    const testError = new Error('AppSignal Test Error ' + new Date().toISOString());
    console.log('[AppSignal Test] Sending test error:', testError.message);
    window.ErrorReporter.error(testError, { test: true, timestamp: Date.now() });
    console.log('[AppSignal Test] ✅ Test error sent! Check AppSignal dashboard.');
    return true;
  } catch (e) {
    console.error('[AppSignal Test] FAIL:', e);
    return false;
  }
};

// Auto-trigger test if URL has ?test_appsignal=1
if (typeof window !== 'undefined') {
  const urlParams = new URLSearchParams(window.location?.search || '');
  if (urlParams.get('test_appsignal') === '1') {
    // Wait for page to fully load before triggering test
    window.addEventListener('load', function() {
      setTimeout(function() {
        console.log('[AppSignal Test] Auto-triggered via URL parameter');
        window.testAppSignal();
      }, 2000); // Wait 2 seconds for everything to initialize
    });
  }
}

if (window.location.hostname === 'crm.warmlyyours.com') {
  XMLHttpRequest.onerror = window.reportErrorToUser;
}

